<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.perintah }}</strong>
          </p>
        </template>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalKontrak-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalKontrak" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaStatusPoolKontrakAktif-filter>
                <b-form-select v-model="filter.statusPoolKontrakAktif" :options="optionsStatusPoolKontrakAktif"></b-form-select>
              </template>
              <template #Actions="{ item }">
                <td class="flex">
                  <b-button
                    v-if="item.statusPoolKontrakAktif == 8"
                    variant="warning"
                    class="mr-1 mb-1"
                    v-c-tooltip.hover.click="'Edit Data'"
                    v-b-modal.modal-edit
                    @click="(data = item), setEdit(), (edit = !edit)"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-pencil"
                  /></b-button>
                  <b-button variant="info" class="mr-1 mb-1" v-c-tooltip.hover.click="'Detail'" v-b-modal.modal-detail @click="(data = item), setEdit(), (detail = !detail)"
                    ><CIcon name="cil-info"
                  /></b-button>
                  <b-button variant="success" class="mr-1 mb-1" v-c-tooltip.hover.click="'Upload'" v-b-modal.modal-dokumen-perintah-kerja @click="(data = item), setEdit(), (detail = !detail)"
                    ><CIcon name="cil-paperclip" />{{ item.actions }}</b-button
                  >
                  <b-button variant="secondary" class="mr-1 mb-1" v-c-tooltip.hover.click="'Print Data'" v-b-modal.modal-print @click="setPrint(item)"><CIcon name="cil-print" /></b-button>
                  <b-button
                    v-if="item.statusPoolKontrakAktif == 8 && !item.isMutasi"
                    variant="danger"
                    class="mr-1 mb-1"
                    v-c-tooltip.hover.click="'Hapus Data'"
                    v-b-modal.modal-delete
                    @click="data = item"
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    ><CIcon name="cil-trash"
                  /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <ModalEdit :data="data" :edit="edit" :karyawan="listKaryawan" :dataCabang="listCabang" @alert="triggerAlert($event)" />
    <ModalDetail :data="data" :detail="detail" />
    <ModalDokumen :data="data" :detail="detail" @alert="triggerAlert($event)" />
    <ModalDelete :data="data" :detail="detail" @alert="triggerAlert($event)" />
    <ModalStatus :data="data" :detail="detail" @alert="triggerAlert($event)" />
    <ModalPrint :printData="printData" :manajemen="listManajemen" />
  </CRow>
</template>

<script>
import ModalEdit from "./modalEdit.vue";
import ModalDokumen from "./modalDokumen.vue";
import ModalDetail from "./modalDetail.vue";
import ModalStatus from "./modalStatus.vue";
import ModalDelete from "./modalDelete.vue";
import ModalPrint from "./modalPrint.vue";
import debounce from "lodash/debounce";

export default {
  components: {
    ModalEdit,
    ModalDetail,
    ModalDokumen,
    ModalStatus,
    ModalDelete,
    ModalPrint,
  },
  name: "perintah",
  data() {
    return {
      edit: false,
      detail: false,
      printData: null,
      data: {},
      listKaryawan: [],
      listMitra: [],
      listCabang: [],
      listManajemen: [],
      items: [],

      filter: {
        tanggalKontrak: null,
        statusPoolKontrakAktif: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusPoolKontrakAktif: [
        { value: null, text: "Pilih" },
        { value: "0", text: "Aktif" },
        { value: "1", text: "Habis Kontrak" },
        { value: "2", text: "Diberhentikan" },
        { value: "3", text: "Resign" },
        { value: "4", text: "Diperpanjang" },
        { value: "5", text: "Mutasi Penempatan" },
        { value: "6", text: "Meninggal" },
        { value: "7", text: "Tanpa Keterangan" },
        { value: "8", text: "Belum Aktif" },
        { value: "9", text: "Pensiun" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "nomorSuratPerintah",
          label: this.$store.state.table.nomorSuratPerintah,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "nomorSuratPerjanjian",
          label: this.$store.state.table.nomorSuratPerjanjian,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalKontrak",
          label: this.$store.state.table.namaTanggalKontrak,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "masaBerlakuKontrak",
          label: this.$store.state.table.masaBerlakuKontrak,
          _style: "max-width: 5%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "penempatan",
          label: this.$store.state.table.penempatan,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaStatusPoolKontrakAktif",
          label: this.$store.state.table.namaStatusPoolKontrakAktif,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.actions,
          _style: "min-width: 20%;",
          class: "table-option-4 text-center",
          filter: false,
          sorter: false,
        },
      ];
      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }
      return x;
    },
  },
  mounted() {
    this.getDatas();
    this.getKaryawan();
    this.getCabang();
    this.getManajemen();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    filter: {
      deep: true,
      handler() {
        this.debounceGetDatas();
      },
    },
  },
  methods: {
    debounceGetDatas: debounce(function () {
      this.getDatas();
    }, 1000),
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      this.debounceGetDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPerintahKerja = await vm.$axios.post("/poolKontrak/listPerHalaman", {
        ...vm.filter,
        tanggalKontrak: vm.filter.tanggalKontrak ? vm.$moment(vm.filter.tanggalKontrak).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listPerintahKerja", listPerintahKerja);
      vm.items =
        listPerintahKerja.data.status == 200
          ? listPerintahKerja.data.data.map((x, idx) => {
              vm.optionsStatusPoolKontrakAktif.forEach((item) => {
                if (x.statusPoolKontrakAktif == item.value) x.namaStatusPoolKontrakAktif = item.text;
              });
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.poolKontrakId,
                namaMitra: x.namaMitra || " - ",
                namaTanggalKontrak: vm.$moment(x.tanggalKontrak).format("LL"),
                namaJatuhTempoKontrak: vm.$moment(x.jatuhTempoKontrak).format("LL"),
              };
            })
          : [];
      vm.totalRows = parseInt(listPerintahKerja.data.count);
      vm.loading = false;
    },
    async getKaryawan() {
      let vm = this;
      let listKaryawan = await vm.$axios.get("dataKaryawan/listKaryawan");
      vm.listKaryawan =
        listKaryawan.data.status == 200
          ? listKaryawan.data.data.map((x) => {
              return {
                ...x,
                namaKaryawan: x.namaKaryawan + " - " + x.penempatan,
              };
            })
          : [];
    },
    // async getMitra() {
    //   let vm = this;
    //   let listMitra = await vm.$axios.get("mitra/list");
    //   vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : [];
    // },
    async getCabang() {
      let vm = this;
      let listCabang = await vm.$axios.get("cabang/list");
      vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : [];
    },
    async getManajemen() {
      let vm = this;
      let listManajemen = await vm.$axios.get("masterManajemen/list");
      vm.listManajemen = listManajemen.data.status == 200 ? listManajemen.data.data : [];
    },
    setEdit() {
      let vm = this;
      for (let i = 0; i < vm.listKaryawan.length; i++) {
        if (vm.data.dataKaryawanId == vm.listKaryawan[i].dataKaryawanId) {
          vm.data.dataKaryawanIdEdit = vm.listKaryawan[i];
        }
        vm.data.tanggalKontrakEdit = vm.$moment(vm.data.tanggalKontrak).format("DD/MM/YYYY");
      }
    },
    async setPrint(x) {
      let vm = this;
      let print = await vm.$axios.get("/poolKontrak/cetakSuratPerintah/" + x.poolKontrakId);
      // console.log(print.data.data[0],'super');
      vm.printData = print.data.data[0];
      vm.printData.alamatKaryawanPrint = vm.printData.alamatKaryawan;
      vm.printData.tanggalKontrakPrint = vm.$moment(vm.printData.tanggalKontrak).format("LL");
      vm.printData.jatuhTempoKontrakPrint = vm.$moment(vm.printData.jatuhTempoKontrak).format("LL");
      vm.printData.tanggalDibuatSuratPrint = vm.$moment(vm.printData.tanggalDibuatSurat).format("LL");
      vm.printData.namaPejabatManajemenModal = "";
      vm.printData.posisiManajemenModal = "";
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
